export default "__VITE_ASSET__BDGz21S4__"